import './Success.css';

const Success = () => {
    return (
        <>
            <div className={"header"}>
                <img className="header-image" src={require("../assets/irina_pp.png")} alt="logo" />
                <div className={"header-text"}>
                    <h1 className="header-title">Irina</h1>
                    <h3 className="header-subtitle">La voyante préférée des Stars</h3>
                </div>
            </div>
            <div className="success-content">
                <h1 className={"title"}>Je tiens à exprimer ma sincère gratitude,</h1>
                <p className={"subtitle"}>Merci pour la confiance que vous m'accordez.</p>
                <p className={"subtitle"}>À l'instant où vous parcourez ces mots, vous avez sans doute déjà reçu un courriel contenant vos premiers présents d'amitié.</p>
                <p className={"subtitle"}>Afin de confirmer la réception de ces éléments...</p>
                <ul className={"list"}>
                    <li className={"list-item"}>Veuillez consulter votre boîte de réception pour repérer mon message (n'oubliez pas de vérifier vos courriers indésirables si nécessaire).</li>
                    <li className={"list-item"}>Ouvrez ce message et cliquez sur le lien pour découvrir vos cadeaux.</li>
                    <li className={"list-item"}>N'hésitez pas à m'ajouter immédiatement à vos contacts pour ne manquer aucune de mes prochaines prévisions.</li>
                </ul>
                <p className={"subtitle spacing"}>De mon côté, grâce aux informations que vous avez partagées, je vais immédiatement consulter les astres en votre faveur.</p>
                <p className={"subtitle"}>Pour cela, je vais d'abord déterminer la méthode de divination qui vous convient le mieux... cela peut être les tarots, la boule de cristal, le pendule, voire même les trois simultanément. Je peux également explorer d'autres méthodes de divination plus confidentielles et secrètes en fonction de l'urgence de votre situation.</p>
                <p className={"subtitle spacing"}>Quoi qu'il en soit, je tiens à vous assurer que je mobiliserai toutes mes ressources pour vous fournir des réponses claires et précises concernant votre situation présente et votre avenir imminent.</p>
                <p className={"subtitle spacing"}>Car c'est avant tout ce dont vous avez besoin aujourd'hui.</p>
                <p className={"subtitle spacing"}>Il est temps pour moi de me mettre au travail. Ainsi, faites attention à vos messages. Ma réponse ne devrait pas tarder à arriver.</p>
                <p className={"subtitle spacing"}>Dès à présent, considérez que je ferai tout pour vous aider.</p>
                <div className={"signature"}>
                    <p className={"subtitle spacing"}>Votre voyante personnelle,</p>
                    <p className={"signature-text spacing"}>Irina.</p>
                </div>
            </div>
        </>
    )
}

export default Success;